module.exports = __webpack_public_path__ + "img/anikeeva.44bd3c3e.jpg";